/**
 * @desc 物流分组更新
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsChannelLogisticsGroupUpdateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/logisticsGroup/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
